module.exports = __webpack_public_path__ + "static/media/Woman-with-gold-mask-586432.96621dc6.jpg";